import { CoreIcon } from '../core-icon';
import bankLinepaySquareSVG from '../../assets/logos/bank-linepay-square.svg';
import type { IconProps } from '../core-icon';

export const BankLinepaySquareIcon = (props: Omit<IconProps, 'src'>) => {
  return <CoreIcon src={bankLinepaySquareSVG} {...props} />;
};
